
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/public_agreement",
      function () {
        return require("private-next-pages/public_agreement.tsx");
      }
    ]);
  